<main class="dialog-body">
  <div class="dialog-header">
    <div class="d-flex align-items-center gap-3">
      <div class="back-button" *ngIf="stepSubmit" (click)="goStepone()">
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      </div>
      <div class="dialog-header-text">
        {{ isEdit ? "Edit student details" : "Add student details" }}
      </div>
    </div>
    <div
      class="cross-icon"
      (click)="onCancel()"
      [class.disabled]="isProcessing"
    >
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content" *ngIf="!stepSubmit">
    <form [formGroup]="form" class="d-grid gap-14">
      <div class="grid-container">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="First name"
            placeholder="Enter your first name"
            type="text"
            [control]="form.get('firstName')"
            [required]="true"
            [customErrorMessages]="customErrorMessages.firstName"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Last name"
            placeholder="Enter your last name"
            type="text"
            [control]="form.get('lastName')"
            [required]="true"
            [customErrorMessages]="customErrorMessages.lastName"
          >
          </app-input>
        </div>
      </div>

      <div class="grid-container">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Email (School)"
            placeholder="Enter your school email"
            type="text"
            [control]="form.get('schoolEmail')"
            [required]="true"
            [customErrorMessages]="customErrorMessages.schoolEmail"
          >
          </app-input>
        </div>
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Email (personal)"
            [optional]="true"
            placeholder="Enter your personal email"
            type="text"
            [control]="form.get('personalEmail')"
            [customErrorMessages]="customErrorMessages.personalEmail"
          >
          </app-input>
        </div>
      </div>

      <div class="grid-container">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Date of birth"
            placeholder="Enter your date of birth"
            type="date"
            [control]="form.get('dob')"
            [required]="true"
            [dateType]="true"
            [customErrorMessages]="customErrorMessages.dob"
            (valueChange)="onDobChange()"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Year level/Grade"
            [required]="false"
            placeholder="Enter your year level"
            type="select"
            [control]="form.get('yearLevel')"
            [options]="yearLevelOption"
            [customErrorMessages]="customErrorMessages.yearLevel"
          >
          </app-input>
        </div>
      </div>

      <div class="grid-container">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Parent/Guardian full name"
            placeholder="Enter parent/guardian full name"
            type="text"
            [control]="form.get('parentName')"
            [required]="true"
            [customErrorMessages]="customErrorMessages.parentName"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Parent/Guardian email"
            placeholder="Enter parent/guardian email"
            type="text"
            [control]="form.get('parentEmail')"
            [required]="true"
            [customErrorMessages]="customErrorMessages.parentEmail"
          >
          </app-input>
        </div>
      </div>

      <div class="grid-container">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Gender"
            placeholder="Select Gender"
            type="select"
            [control]="form.get('gender')"
            [options]="genderOption"
            [required]="true"
            [customErrorMessages]="customErrorMessages.gender"
          >
          </app-input>
        </div>
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Ethnicity"
            placeholder="Select your Ethnicity"
            type="select"
            [control]="form.get('ethnicity')"
            [required]="true"
            [options]="ethnicityOption"
            [customErrorMessages]="customErrorMessages.ethnicity"
          >
          </app-input>
        </div>
      </div>

      <div class="d-grid gap-3">
        <div class="question-grid">
          <div class="primary-text">
            1. In the past 12 months, have you (or the student) been enrolled in any construction-related course at any level (e.g., school, vocational training, or tertiary education)?
            <span style="color: red;">*</span>
          </div>
          <div>
            <app-input
              context="Normal"
              class="form-item"
              placeholder="Select"
              [required]="true"
              type="select"
              [control]="form.get('constructionCourse')"
              [options]="dataOption"
              [customErrorMessages]="customErrorMessages.constructionCourse"
            ></app-input>
          </div>
        </div>

        <div class="checkbox-grid" *ngIf="showConstructionCourseAnswers">
          <div
            *ngFor="let area of constructionPastAnswers"
            class="checkbox-wrapper"
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                [value]="area.id"
                (change)="onFocusAreaChange($event, 1)"
                [checked]="form.get('pastAnswers')?.value?.includes(area.id)"
              />
              <span class="checkmark"></span>
              <span class="form-label2">{{ area.courseName }}</span>
            </label>
          </div>
        </div>
        <div class="error-message-container" *ngIf="showPastAnswersError">
          <div class="error-message">Please select at least one course.</div>
        </div>

        <div class="question-grid">
          <div class="primary-text">
            2. Are you (or the student) currently enrolled in, or have you (they) previously completed, any construction-related courses?
            <span style="color: red;">*</span>
          </div>
          <div>
            <app-input
              context="Normal"
              class="form-item"
              placeholder="Select"
              [required]="true"
              type="select"
              [control]="form.get('constructionRelatedCourse')"
              [options]="dataOption"
              [customErrorMessages]="
                customErrorMessages.constructionRelatedCourse
              "
            ></app-input>
          </div>
        </div>

        <div class="checkbox-grid" *ngIf="showConstructionRelatedCourseAnswers">
          <div
            *ngFor="let area of constructionCompAnswers"
            class="checkbox-wrapper"
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                [value]="area.id"
                (change)="onFocusAreaChange($event, 2)"
                [checked]="
                  form.get('completedAnswers')?.value?.includes(area.id)
                "
              />
              <span class="checkmark"></span>
              <span class="form-label2">{{ area.courseName }}</span>
            </label>
          </div>
        </div>
        <div class="error-message-container" *ngIf="showCompAnswersError">
          <div class="error-message">Please select at least one course.</div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-content" *ngIf="stepSubmit">
    <div class="secondForm-text">
      <div>
        By completing this form and providing the student's personal
        information, you are agreeing to CSQ and its Construction Pathways event
        partners collecting, storing and using the student's personal
        information for its legally mandated purposes, including for statistical
        and analytical purposes.
      </div>
      <div>
        You agree to indemnify CSQ against any liability for any loss or damage
        suffered in connection with the unauthorised use of their personal
        information by a party other than CSQ
      </div>
      <div>
        CSQ is committed to protecting the confidentiality, security and privacy
        of personal information held in our records and has in place appropriate
        measures to offer that protection.
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="action-buttons">
    <button
      class="dialog-button cancel-button"
      (click)="onCancel()"
      [disabled]="isProcessing"
    >
      Cancel
    </button>
    <button
      class="dialog-button update-button"
      (click)="onSave()"
      [disabled]="isProcessing"
      *ngIf="!stepSubmit"
    >
      <span *ngIf="!isProcessing">{{ isEdit ? "Update" : "Submit" }}</span>
      <span *ngIf="isProcessing" class="submit-loading">
        <span class="spinner"></span>
        Submiting...
      </span>
    </button>
    <button
      class="dialog-button update-button"
      (click)="onSubmit()"
      [disabled]="isProcessing"
      *ngIf="stepSubmit"
    >
      <span *ngIf="!isProcessing">{{ isEdit ? "Update" : "Submit" }}</span>
      <span *ngIf="isProcessing" class="submit-loading">
        <span class="spinner"></span>
        Submiting...
      </span>
    </button>
  </mat-dialog-actions>
</main>
